var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClass = function SvgClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.3 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m0-1.8a2.699 2.699 0 0 0 1.033-5.194A2.7 2.7 0 1 0 9.3 10.2m6.3 9.9a.9.9 0 1 1-1.8 0v-1.8a2.7 2.7 0 0 0-2.7-2.7H7.5a2.7 2.7 0 0 0-2.7 2.7v1.8a.9.9 0 0 1-1.8 0v-1.8a4.5 4.5 0 0 1 4.5-4.5h3.6a4.5 4.5 0 0 1 4.5 4.5zm.9-4.5a.9.9 0 1 1 0-1.8 4.5 4.5 0 0 1 4.5 4.5v1.8a.9.9 0 1 1-1.8 0v-1.8a2.7 2.7 0 0 0-2.7-2.7M14.7 12a.9.9 0 1 1 0-1.8 2.7 2.7 0 0 0 0-5.4.9.9 0 0 1 0-1.8 4.5 4.5 0 1 1 0 9"
  })));
};
export default SvgClass;